/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {createSelector} from 'reselect';
import {DashboardId} from '@ion/core/src/services/Sisense';

const selectIsTokenRegistered       = ({reports: {isTokenRegistered}}): boolean => isTokenRegistered;
const selectSisenseDefaultDashboard = ({reports: {sisense: {defaultDashboard}}}): DashboardId => defaultDashboard;

export const isTokenRegisteredSelector = createSelector(selectIsTokenRegistered,
  (isTokenRegistered: boolean): boolean => isTokenRegistered
);

export const sisenseDefaultDashboardSelector = createSelector(selectSisenseDefaultDashboard,
  (selectSisenseDefaultDashboard: DashboardId): DashboardId => selectSisenseDefaultDashboard
);
